import { useState } from 'react'

import { Card } from '~/components/Card'
import { SplitsLink as Link } from '~/components/Link'
import { LogoutButton } from '~/components/LogoutButton'
import { Button, PageLayout } from '~/components/component-library'
import { Dialog } from '~/components/component-library/Dialog'
import { NewOrgModal } from '~/components/settings/NewOrgModal'

export const EmptyTeamsPage = () => {
  const [isNewTeamModalOpen, setIsNewTeamModalOpen] = useState(false)

  return (
    <PageLayout>
      <Card>
        <div className="mt-1 flex w-full flex-col space-y-8 px-4 md:p-0">
          <div className="flex flex-col space-y-2">
            <h1 className="text-2xl font-semibold">Welcome</h1>
            <div className="text-md text-secondary">
              To get started, create your first workspace.
              <br /> To learn more about Splits, visit the{' '}
              <Link path="https://splits.org/docs" underline target="tab">
                docs
              </Link>
              .
            </div>
          </div>
          <div className="mt-4 flex space-x-2">
            <Button onClick={() => setIsNewTeamModalOpen(true)}>
              Create workspace
            </Button>
            <LogoutButton />
          </div>
        </div>
      </Card>
      <Dialog open={isNewTeamModalOpen} onOpenChange={setIsNewTeamModalOpen}>
        <NewOrgModal
          isModalOpen={isNewTeamModalOpen}
          setIsModalOpen={setIsNewTeamModalOpen}
        />
      </Dialog>
    </PageLayout>
  )
}
